

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Address } from 'cluster';
import { Payers } from '../masters/payers';

export interface PatientPayerParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientPayer {
    id?: any;
    tenantId: any;
    branchId: any;
    regId: any;

    payerType: string;
    isDefault: boolean;
    insName: string;
    insPolicyFor: string;
    insCardNumber: string;
    insPolicyName: string;
    insPolicyNumber: string;
    insValidUpto: Date;
    insSelfOrFamily: string;
    insPolicyHolderName: string;
    insPolicyHolderEmployment: string;
    corpNameOfOrganization: string;
    corpSelfOrFamily: string;
    corpEmpName: string;
    corpEmpId: string;
    corpEmpDesignation: string;
    corpEmpDepartment: string;
    sponName: string;
    sponNotes: string;
    corpDet: Payers;
    sponDet: Payers;
    insDet: Payers;
    // sponTrustLicene: string;
    // sponContactPerson: string;
    // sponContactMobile: string;
    // sponWorkPhone: string;
    // sponEmail: string;
    // sponWebsite: string;
    // sponAddress: string;
    primaryBeneficiaryEmpId: string;
    insurerMemberId: string;

    creditLimit: any;
    approvalAmt: any;
    status: number;
    claimAuthorizationNo: string;
    applyOrgRate?: string;
    ipBillId?:any;
    opBillId?:any;
    subType?:string;
    ChecklistDoneMst:checkListDetail[];

    parameters?: PatientPayerParameter[];
    links?: any;
    same_payer_for_multiple_bills?:string;
    isAmtValidationFlag?:boolean;

}

export interface checkListDetail {
    docName: any;
    doneBy: any;
    doneDate: Date;
    approvedBy: any;
    approvedDate: Date;
    notes: string;
}


export abstract class PatientPayerData {
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<PatientPayer[]>;
    abstract create(url: string, data: PatientPayer): Observable<PatientPayer[]>;
    abstract update(url: string, data: PatientPayer): Observable<PatientPayer>;
    abstract delete(url: string): Observable<any>;
}
